import { useContext } from "react";
import { Trans } from "react-i18next";
import { LANGUAGE } from "../type";
import { Context } from "../ContextProvider";
import heckgarageWoMoDSC from "../assets/images/heckgarage_WoMo_DSC_3605_frei.png";
import rnThin from "../assets/icons/rv_thin.svg";

function getFlyerUrl(language: string) {
  switch (language) {
  case LANGUAGE.FR:
    return "https://allsafe.canto.de/direct/document/3f9s749nh54p78khrht2l53363/n8me9TovdTwaa7QpVv8RULvzZck/original?content-type=application%2Fpdf&name=WohnmobilHeckgarage_idP_592021-FR.pdf";
  case LANGUAGE.DE:
    return "https://allsafe.canto.de/direct/document/0eifdq685t4evdpe8sp044fu7f/a1fJVSadCxC3nfRmtHgTRiBsTcU/original?content-type=application%2Fpdf&name=PI_WohnmobilHeckgarage_DE.pdf";
  case LANGUAGE.EN:
    return "https://allsafe.canto.de/direct/document/03vj78u7pt2kr6mdgv9615mv00/GodF9aWfhVaIfo32jz4Umd8e7fY/original?content-type=application%2Fpdf&name=PI_WohnmobilHeckgarage_EN.pdf";
  default:
    return "https://allsafe.canto.de/direct/document/03vj78u7pt2kr6mdgv9615mv00/GodF9aWfhVaIfo32jz4Umd8e7fY/original?content-type=application%2Fpdf&name=PI_WohnmobilHeckgarage_EN.pdf";
  }
}

const SecuringSection = () => {
  const { language } = useContext(Context);

  return (
    <section className="mt-32 px-6 max-w-screen-2xl mx-auto lg:mt-44 2xl:px-0">
      <div className="flex flex-col lg:flex-row items-center space-y-6 lg:space-x-6">
        <div className="basis-1/2 lg:mb-0 lg:h-80">
          <img
            src={heckgarageWoMoDSC}
            alt="heckgarageWoMoDSC"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="basis-1/2 lg:w-full">
          <h1 className="font-Roboto font-normal text-4xl leading-10 text-allsafe-blue lg:text-6xl lg:leading-[70px]">
            <Trans i18nKey="cargoSecurityRearGarage">Ladungssicherung in der Wohnmobil-Heckgarage</Trans>
          </h1>
          <h3 className="text-2xl font-Roboto font-normal text-allsafe-blue my-4">
            <Trans i18nKey="noProblemWithAllsafe">
              Kein Problem mit allsafe!
            </Trans>
          </h3>
          <p className="font-Roboto font-normal text-base leading-6 mb-6">
            <Trans i18nKey="cargoSecurityRearGarage">
              Wir bieten individuelle Lösungen um die Ladung in der Heckgarage
              professionell zu sichern. Egal ob es sich um ein neues Fahrzeug
              handelt oder ob Sie die Heckgarage an einem bestehenden Fahrzeug
              nachrüsten wollen. Sprechen Sie uns an und gemeinsam finden wir
              eine passende Lösung für Ihren Anwendungsfall.
            </Trans>
          </p>
          <div className="flex gap-x-8 mb-8">
            <div className="w-16 h-12">
              <img src={rnThin} alt="rnThin" className="w-full h-full" />
            </div>
            <div className="font-Roboto font-normal text-sm leading-6">
              <p className="font-Roboto font-normal text-base leading-6">
                <Trans i18nKey="exploreMoreRear">
                  Werfen Sie einen Blick auf unseren
                </Trans>
              </p>
              <a
                href={getFlyerUrl(language)}
                target="_blank"
                rel="noreferrer"
                className="font-Roboto font-normal text-base leading-6 text-allsafe-blue"
              >
                <Trans i18nKey="rearGarageFlyer">Heckgaragen-Flyer.</Trans>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuringSection;
